import { SUPPORTED_TYPES } from '../panels/patientHistory/eventLogger/supportedTypes'
import { useGetAdvancedPatientHistoryFormTypesQuery } from './advancedPatientHistoryFormTypes.generated'

// Notes only some programs or health plans carry, so a program with no allow-list does not get them.
const PROGRAM_SPECIFIC_TYPES = [
  'FINANCIAL_ELIGIBILITY_HEALTH_PLAN',
  'WHO5',
  'INTAKE_NOTE_COACHING',
  'ADVANCED_FOLLOW_UP_NOTE',
  'MONTHLY_SUMMARY_NOTE',
  'TREATMENT_PLAN_COMPREHENSIVE',
  'TREATMENT_PLAN_COMPREHENSIVE_UPDATE',
  'INTAKE_NOTE_COMPREHENSIVE',
]

// Only used when the server's per-program allow-list is empty; a populated one still wins.
const FALLBACK_TYPES = SUPPORTED_TYPES.filter((type) => !PROGRAM_SPECIFIC_TYPES.includes(type))

export const usePatientHistoryFormTypes = (uid: string): string[] => {
  const { data, loading } = useGetAdvancedPatientHistoryFormTypesQuery({ variables: { uid } })
  const types = data?.patient?.program?.patientHistoryTypes

  if (loading) return []

  return types && types.length > 0 ? types : FALLBACK_TYPES
}
